import type { ApiResult, Wait } from "./ports";

/** 秒数不明でも即時再送を避けつつ、読者を長く待たせない最小待機。 */
const RETRY_AFTER_FALLBACK_SECONDS = 1;
/** 悪意ある・壊れたヘッダーでSDKが長時間止まらないための待機上限。 */
const RETRY_AFTER_MAX_SECONDS = 60;

/** service_busyだけRetry-Afterを安全な範囲へ補正して待ち、同じ操作を最大1回再送する。 */
export async function withServiceBusyRetry<T>(
  operation: () => Promise<ApiResult<T>>,
  wait: Wait,
): Promise<ApiResult<T>> {
  const firstResult = await operation();
  if (!firstResult.ok && firstResult.error.code === "service_busy") {
    // アダプタ以外の実装が0を返しても、coreの再送規則として1〜60秒の範囲を保証する。
    const retryAfterSeconds = Math.min(
      Math.max(
        firstResult.error.retryAfterSeconds ?? RETRY_AFTER_FALLBACK_SECONDS,
        RETRY_AFTER_FALLBACK_SECONDS,
      ),
      RETRY_AFTER_MAX_SECONDS,
    );
    await wait(retryAfterSeconds * 1000);
    return operation();
  }
  return firstResult;
}
